import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import client from 'apollo/client';
import { useTranslation } from 'react-i18next';
import { IoIosArrowForward } from 'react-icons/io';

import { ROUTES } from 'utils/constants';
import { resetAnalyticsUser } from 'utils/analytics';

import SolidButton from 'components/SolidButton';
import UserName from '../UserName';

const ProfileContent = ({ onGoPersonalData }) => {
  const { t } = useTranslation();
  const { replace } = useHistory();

  const handleLogout = async () => {
    await client.clearStore();
    localStorage.clear();
    resetAnalyticsUser();
    replace(ROUTES.EVIE_LOGIN); // OR CREATE A NEW VIEW LIKE IN MOBILE
  };

  return (
    <section className="evie-profile">
      <header className="evie-profile__header">
        <h2 className="evie-profile__header_title">{t('evieApp.profile.title')}</h2>
      </header>
      <UserName />
      <h3 className="evie-profile__settings_title">{t('evieApp.profile.settings.title')}</h3>
      <ul className="evie-profile__settings_list">
        <li>
          <button type="button" className="evie-profile__setting" onClick={onGoPersonalData}>
            <div className="evie-profile__setting_labels">
              <h4>{t('evieApp.profile.settings.setting.data')}</h4>
              <p>{t('evieApp.profile.settings.setting.see')}</p>
            </div>
            <IoIosArrowForward size={24} color="#9b2c51" />
          </button>
        </li>
      </ul>
      <ul className="evie-profile__terms">
        <li>
          <button type="button" className="evie-profile__terms_item">
            {t('evieApp.profile.terms.terms')}
          </button>
        </li>
        <li>
          <button type="button" className="evie-profile__terms_item">
            {t('evieApp.profile.terms.privacy')}
          </button>
        </li>
      </ul>
      <div className="evie-profile__logoutbtn">
        <SolidButton className="evie-survey evie-profile__logoutbtn_btn" onClick={handleLogout}>
          {t('button.logout')}
        </SolidButton>
      </div>
    </section>
  );
};

ProfileContent.propTypes = {
  onGoPersonalData: PropTypes.func.isRequired,
};

export default ProfileContent;
